import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo} from "react-icons/pi";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";

export default function PurchaseOrders(){
  const { purchase_orders,weclappBaseUrl, col_definitions } = usePage().props;
  const [showModal,setShowModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const {t} = useEnhancedTranslation();

  const openImportFor = (id) => {
    setSelectedDocumentId(id);
    setShowModal(true);
  }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/purchase-order/${id}`, '_blank');
    }

  return (
    <>
      <InertiaTable
        key={'purchaseorders-table'}
        data={purchase_orders}
        title={
          <span className="d-inline-flex align-items-center gap-2">
            Einkauf – Bestellungen
            <HelpTooltip placement="right" size={0.95}>
              <div className="text-start">
                <strong>Welche Belege werden hier angezeigt?</strong>
                <div className="mt-1">Einkaufsbestellungen aus Weclapp nach festen Regeln:</div>
                <ul className="mb-0 ps-3 mt-1">
                  <li>Belegtyp: <strong>Einkaufsbestellung</strong> (Purchase Order)</li>
                  <li>Status: <strong>ORDER_ENTRY_IN_PROGRESS</strong> – Bestellung wird gerade erfasst</li>
                </ul>
                <div className="mt-1">Sortierung: Nummer absteigend.</div>
              </div>
            </HelpTooltip>
          </span>
        }
        colDefinitions={[...col_definitions]}
        actionsDisplay={'column'}
        actions={[
            { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) =>openImportFor(data.id) },
            { icon: <WeclappIcon />, alt:  t('open in Weclapp'), callback: (data) =>openWeclappOrder(data.id) },

        ]}
        customCellRendererMap={{
        'orderDate': TimestampTableCell,
        'createdDate':TimestampTableCell
    }}
      />
      <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'purchase_order'} onClose={()=>setShowModal(false)} />
    </>
  );
}
